import React from "react";

import { copy } from "shared/assets";
import { VisuallyHiddenElement } from "shared/styles/constants";
import { Asterisk } from "./styles";

export const Required: React.FC = () => (
  <Asterisk>
    <VisuallyHiddenElement>{copy.form.required}</VisuallyHiddenElement>
  </Asterisk>
);
